import { LuIcon, Menu } from "@overmap-ai/blocks"
import { type ChangeEvent, type ComponentPropsWithRef, memo, useCallback } from "react"

import { useFileInputRef } from "../../hooks/utils"
import { modelIconMapping } from "../../mappings/icons"

interface FileInputMenuItemProps extends Omit<ComponentPropsWithRef<typeof Menu.Item>, "closeOnSelect" | "children"> {
	onAttachFiles?: (files: File[]) => void
}

export const FileInputMenuItem = memo<FileInputMenuItemProps>((props) => {
	const { ref, onAttachFiles, onSelect, ...rest } = props
	const [fileInputRef, handleTriggerFileInput] = useFileInputRef()

	const handleSelect = useCallback(() => {
		onSelect?.()
		handleTriggerFileInput()
	}, [handleTriggerFileInput, onSelect])

	const handleFileInputChange = useCallback(
		(event: ChangeEvent<HTMLInputElement>) => {
			const { files } = event.target
			if (!files) return
			onAttachFiles?.(Array.from(files))
		},
		[onAttachFiles],
	)

	return (
		<Menu.Item ref={ref} onSelect={handleSelect} closeOnSelect={false} {...rest}>
			<LuIcon icon={modelIconMapping.attachment} />
			Attach
			<input className="hidden" multiple type="file" ref={fileInputRef} onChange={handleFileInputChange} />
		</Menu.Item>
	)
})
FileInputMenuItem.displayName = "AttachmentGroup"
